import { SummarizerConfig } from '../../types/summarizer';

export const webPageSummarizerConfig: SummarizerConfig = {
  // Basic identification
  id: 'web-page-summarizer',
  title: 'Web Page Summarizer',
  description: 'Summarize any web page, article, or blog post with AI analysis',
  version: '1.0.0',

  // Categorization
  category: 'web',
  tags: ['webpage', 'article', 'blog', 'news', 'content'],

  // Input configuration
  inputs: {
    file: {
      enabled: false, // Web pages are accessed via URL
    },
    url: {
      enabled: true,
      placeholder: 'Enter web page URL',
      // validation: /^https?:\/\/.+/,
      examples: [
        'https://example.com/article',
        'https://blog.example.com/post-title',
        'https://news.example.com/breaking-news',
        'https://medium.com/@user/article-title',
      ],
      helpText:
        'Enter any publicly accessible web page URL. Works with most websites, blogs, news sites, and documentation.',
      showExamples: true,
      showHelpText: true,
    },
    text: {
      enabled: true,
      placeholder: 'Or paste the web page content/HTML here',
      maxLength: 100000,
      minLength: 100,
      rows: 10,
      helpText: 'Paste HTML content or plain text from any web page.',
      showHelpText: true,
    },
  },

  // Output features
  outputs: {
    summary: true,
    chat: true,
    mindmap: true,
    translation: true,
    keyPoints: true,
    transcript: true,
    download: true,
    share: true,
  },

  // Backend integration
  api: {
    endpoint: '/summarize',
    method: 'POST',
    contentType: 'webpage',
    timeout: 60000, // 60 seconds for web scraping
  },

  // UI customization (Level 1: Basic styling)
  ui: {
    // Basic styling
    primaryColor: '#2563eb',
    secondaryColor: '#3b82f6',
    icon: '🌐',
    theme: 'light',
    // Custom loading messages for web page content
    loadingMessages: {
      aiGeneration: {
        title: 'AI is analyzing the web page...',
        subtitle: 'Fetching content, extracting key information, and generating insights.',
      },
      translation: {
        title: 'Translating web page summary to {language}...',
        subtitle: 'Converting your web page summary to the selected language.',
      },
      streaming: {
        indicator: 'Analyzing web content...',
      },
    },
  },

  // Validation rules
  validation: {
    required: true,
    minSize: 0,
    maxSize: 0, // No file size limit for URLs
    allowedDomains: [], // Allow all domains
    blockedDomains: ['localhost', '127.0.0.1', 'private.com'],
  },

  // Feature flags
  features: {
    beta: false,
    premium: false,
    experimental: false,
  },

  // Metadata
  author: 'TubeOnAI',
  createdAt: '2024-01-01',
  updatedAt: '2024-01-01',
};
